// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TagsTwoToneSvg from "@ant-design/icons-svg/es/asn/TagsTwoTone";
import AntdIcon from '../components/AntdIcon';

var TagsTwoTone = function TagsTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: TagsTwoToneSvg
  }));
};

TagsTwoTone.displayName = 'TagsTwoTone';
export default React.forwardRef(TagsTwoTone);